import {
  GET_TAI_SAN_THEO_CHO_VAY,
  GET_TAI_SAN_THEO_CHO_VAY_SUCCESS,
  GET_TAI_SAN_THEO_CHO_VAY_FAILURE,
  GET_TAI_SAN,
  GET_TAI_SAN_SUCCESS,
  GET_TAI_SAN_FAILURE,
  GET_LICH_SU_TAI_SAN,
  GET_LICH_SU_TAI_SAN_SUCCESS,
  GET_LICH_SU_TAI_SAN_FAILURE,
} from "./actionTypes";

export const getTaiSanTheoChoVay = (dataSearch) => ({
  type: GET_TAI_SAN_THEO_CHO_VAY,
  dataSearch,
});

export const getTaiSanTheoChoVaySuccess = (data) => ({
  type: GET_TAI_SAN_THEO_CHO_VAY_SUCCESS,
  payload: data,
});

export const getTaiSanTheoChoVayFailure = () => ({
  type: GET_TAI_SAN_THEO_CHO_VAY_FAILURE,
});

export const getTaiSan = (dataSearch) => ({
  type: GET_TAI_SAN,
  dataSearch,
});

export const getTaiSanSuccess = (data) => ({
  type: GET_TAI_SAN_SUCCESS,
  payload: data,
});

export const getTaiSanFailure = () => ({
  type: GET_TAI_SAN_FAILURE,
});

export const getLichSuTaiSan = (dataSearch) => ({
  type: GET_LICH_SU_TAI_SAN,
  dataSearch,
});

export const getLichSuTaiSanSuccess = (data) => ({
  type: GET_LICH_SU_TAI_SAN_SUCCESS,
  payload: data,
});

export const getLichSuTaiSanFailure = () => ({
  type: GET_LICH_SU_TAI_SAN_FAILURE,
});
